import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import ConfirmationModal from 'src/ui/atoms/ConfirmationModal'
import Button from 'src/ui/atoms/Button'
import useProjectApi from '../../useProjectApi'

const DeleteProject = () => {
  const { deleteProject } = useProjectApi()
  const navigate = useNavigate()
  const [deleteModal, setDeleteModal] = useState<boolean>(false)

  const handleDeleteItem = async () => {
    setDeleteModal(false)
    await deleteProject()
    navigate('/projects')
  }

  return (
    <>
      <Button size="M" name="Delete" type="remove" onClick={() => setDeleteModal(true)} />
      {deleteModal && (
        <ConfirmationModal
          title="Are you sure you want to delete this project?"
          actions={
            <>
              <Button size="M" name="Cancel" onClick={() => setDeleteModal(false)} />
              <Button size="M" name="Delete" type="remove" onClick={handleDeleteItem} />
            </>
          }
        />
      )}
    </>
  )
}

export default DeleteProject
